module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOnEdge),
      expression: "showOnEdge"
    }],
    attrs: {
      "width": "100%",
      "viewBox": "0 0 1280 572"
    }
  }, [_c('title', [_vm._v("Lab Doors")]), _vm._v(" "), _c('g', {
    staticClass: "left-lab-door"
  }, [_c('path', {
    attrs: {
      "id": "door_left_glass",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M0 .5h640v570H0z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_frame_left_shadow",
      "fill": "#C1C1C1",
      "fill-rule": "nonzero",
      "d": "M587 1.5h53v570h-53z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_frame_left",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M585 1.5h50v570h-50z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M192.6 571.5h-28.9L585 24.9v37.6z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "left_door_glare_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M131.2 571.5H17.4l439.4-570h113.7z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "warning_sign_3",
      "fill": "#F2C300",
      "fill-rule": "nonzero",
      "d": "M459.9 434.1c2.4-4.3 8.6-4.3 11.1 0l18.2 31.4 18.2 31.4c2.4 4.3-.6 9.6-5.5 9.6h-72.6c-4.9 0-8-5.3-5.5-9.6l18.2-31.4 17.9-31.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "warning_sign_2",
      "fill": "#3A3A3A",
      "fill-rule": "nonzero",
      "d": "M461.9 457.1h6.9v17l-1.3 8.4h-4.2l-1.3-8.4-.1-17zm-.8 32.7c0-1.2.4-2.2 1.1-2.9.7-.7 1.8-1.1 3-1.1 1.3 0 2.3.4 3.1 1.1.8.7 1.1 1.7 1.1 2.9s-.4 2.2-1.1 2.9c-.8.7-1.8 1.1-3.1 1.1s-2.2-.4-3-1.1c-.7-.7-1.1-1.7-1.1-2.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "warning_sign_1",
      "fill": "#3A3A3A",
      "fill-rule": "nonzero",
      "d": "M500 502.4h-69.2c-1.9 0-3.2-2.1-2.2-3.8l17.3-30 17.3-30c1-1.7 3.4-1.7 4.4 0l17.3 30 17.3 30c1 1.7-.2 3.8-2.2 3.8zm7.3-5.4l-18.2-31.4-18.2-31.4c-2.4-4.3-8.6-4.3-11.1 0l-18.2 31.4-18.1 31.4c-2.4 4.3.6 9.6 5.5 9.6h72.7c5 0 8-5.3 5.6-9.6z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_sign_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M512.7 415.9H52.1c-4.3 0-7.9-3.5-7.9-7.9V122.3c0-4.3 3.5-7.9 7.9-7.9h460.7c4.3 0 7.9 3.5 7.9 7.9V408c-.1 4.4-3.7 7.9-8 7.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_sign_1",
      "fill": "#A0D1F2",
      "fill-rule": "nonzero",
      "d": "M512.7 416H52.1c-4.3 0-7.9-3.5-7.9-7.9V232.5h476.4v175.6c0 4.4-3.6 7.9-7.9 7.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_logo_3",
      "fill": "#89C1EF",
      "fill-rule": "nonzero",
      "d": "M100.4 168.7c-3.5 0-6.4 2.9-6.4 6.4 0 3.5 2.9 6.4 6.4 6.4 3.5 0 6.4-2.9 6.4-6.4 0-3.6-2.8-6.5-6.4-6.4zm.1 10.7c-2.4 0-4.3-1.9-4.4-4.3-.1-2.4 1.9-4.3 4.3-4.4 2.4 0 4.3 1.9 4.4 4.3.1 2.4-1.9 4.4-4.3 4.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_logo_2",
      "fill": "#89C1EF",
      "fill-rule": "nonzero",
      "d": "M77.1 169.4c2.8-1.2 4.2-4.5 2.9-7.3-1.2-2.7-4.2-4-6.9-3.1v2c.1-.1.2-.1.3-.2 1.9-.8 4.1.1 4.9 2 .8 1.9-.1 4.1-2 4.9-1.1.5-2.3.4-3.3-.2v2c1.3.4 2.8.4 4.1-.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "door_logo_1",
      "fill": "#89C1EF",
      "fill-rule": "nonzero",
      "d": "M100.9 141.8l-19.6 11.6-.2 2.6 1.6 1.8 3.6-.4 1.4 3.3-2.8 2.2.2 2.4 2.5 2-1.2 3.3-3.4-.2-1.9 1.8.7 3.3-3.5 1.5-2.1-2.6h-2.7l-.5.7v16.2l27.8 16.5 27.8-16.5v-33l-27.7-16.5zm11.6 42.2l-2.8 3-3.5-1.7-2.8 1.1-.7 3.8h-4.3l-1.1-3.6-2.8-1.2-3.2 1.9-3-3.1 2.1-3-1.2-2.8-3.8-1.4v-4l3.6-.9 1.2-2.8-1.9-3.5 2.9-3 3.3 1.9 2.8-1.1 1-3.8h4.2l.9 3.6 2.8 1.2 3.5-1.9 2.8 2.9-1.7 3.3.9 2.6 4 1.2v4.2l-4 1.1-.8 2.6 1.6 3.4z"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "text_2",
      "fill": "#FFF",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "30",
      "letter-spacing": "1"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "73",
      "y": "316"
    }
  }, [_vm._v("TAKE A STAND:")]), _vm._v(" "), _c('tspan', {
    attrs: {
      "x": "73",
      "y": "351"
    }
  }, [_vm._v("Emotional Awakening")])]), _vm._v(" "), _c('text', {
    attrs: {
      "id": "text_1",
      "fill": "#A0D1F2",
      "font-family": "ScopeOne-Regular, Scope One",
      "font-size": "40",
      "letter-spacing": "1"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "158",
      "y": "196"
    }
  }, [_vm._v("A.Y.E. LABS")])])]), _vm._v(" "), _c('g', {
    staticClass: "right-lab-door"
  }, [_c('path', {
    attrs: {
      "id": "right_door_glass",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M640 .5h640v570H640z",
      "opacity": ".5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_5",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M977.7 571.6h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_4",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M934.7 571.6h-70l200-259h70z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_2",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M1031.7 261.6h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M763.7 570.6h-20l200-259h20z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_glare_1",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M988.7 261.6h-70l200-259h70z",
      "opacity": ".2"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_frame_shadow",
      "fill": "#C1C1C1",
      "fill-rule": "nonzero",
      "d": "M695 571.5h-53V1.5h53v265l584.9-.4.2 50-585.1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "right_door_frame",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M690 571.5h-50V1.5h50v260h590v50H690z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_4",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero",
      "d": "M978.8 368H759.6c-10.3 0-18.6-8.3-18.6-18.6V222.6c0-10.3 8.3-18.6 18.6-18.6h219.2c10.3 0 18.6 8.3 18.6 18.6v126.9c0 10.2-8.4 18.5-18.6 18.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "fingerprint_scanner_3",
      "fill": "#FFF",
      "fill-rule": "nonzero",
      "d": "M970.5 356H768.8c-7.8 0-14.1-6.3-14.1-14.1V230.1c0-7.8 6.3-14.1 14.1-14.1h201.7c7.8 0 14.1 6.3 14.1 14.1v111.7c.1 7.9-6.3 14.2-14.1 14.2z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cursor-pointer",
    attrs: {
      "fill": "#7ED320",
      "fill-rule": "nonzero",
      "transform": "translate(880.000000, 229.000000)"
    },
    on: {
      "click": _vm.data.clickHandler
    }
  }, [_c('path', {
    attrs: {
      "d": "M82.3,113.5 L11.6,113.5 C5.4,113.5 0.4,108.5 0.4,102.3 L0.4,11.6 C0.4,5.4 5.4,0.4 11.6,0.4 L82.3,0.4 C88.5,0.4 93.5,5.4 93.5,11.6 L93.5,102.3 C93.4,108.5 88.4,113.5 82.3,113.5 Z",
      "id": "button_3",
      "fill": "#6D8C4A",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M78.9,110.1 L11.2,110.1 C5,110.1 0,105.1 0,98.9 L0,11.2 C0,5 5,0 11.2,0 L78.9,0 C85.1,0 90.1,5 90.1,11.2 L90.1,98.9 C90,105.1 85,110.1 78.9,110.1 Z",
      "id": "button_2",
      "fill": "#7ED320",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "opacity": "0",
      "d": "M24.8875,37 L18.8125,37 C18.745833,36.8999995 18.7125,36.7666675 18.7125,36.6 C18.7125,36.4166657 18.7708328,36.2500008 18.8875,36.1 L20.5625,35.9 L20.5625,22.025 L19.1125,22.025 C18.845832,22.025 18.7125,21.9083345 18.7125,21.675 C18.7125,21.5583328 18.7541663,21.3583348 18.8375,21.075 L18.8875,20.875 L25.1125,20.875 C26.1625053,20.875 27.0499964,21.0249985 27.775,21.325 C28.5000036,21.6250015 29.0833311,22.0166643 29.525,22.5 C29.9666689,22.9833357 30.2916656,23.5124971 30.5,24.0875 C30.7083344,24.6625029 30.8125,25.2249973 30.8125,25.775 C30.8125,26.3250028 30.7083344,26.8874971 30.5,27.4625 C30.2916656,28.0375029 29.9666689,28.5666643 29.525,29.05 C29.0833311,29.5333357 28.5000036,29.9249985 27.775,30.225 C27.0499964,30.5250015 26.1625053,30.675 25.1125,30.675 L21.9625,30.675 L21.9625,35.85 L24.6625,35.85 C24.929168,35.85 25.0625,35.9666655 25.0625,36.2 C25.0625,36.3166673 25.0208338,36.5166653 24.9375,36.8 L24.8875,37 Z M21.9625,29.525 L25.1125,29.525 C26.4125065,29.525 27.4416629,29.1875034 28.2,28.5125 C28.9583371,27.8374966 29.3375,26.9250057 29.3375,25.775 C29.3375,24.6249942 28.9583371,23.7125034 28.2,23.0375 C27.4416629,22.3624966 26.4125065,22.025 25.1125,22.025 L21.9625,22.025 L21.9625,29.525 Z M45.6875,36.65 L43.2125,37.125 C42.9291653,36.9749992 42.6958343,36.7916677 42.5125,36.575 L42.6875,34.075 C42.220831,35.0916717 41.5833374,35.8749972 40.775,36.425 C39.9666626,36.9750027 39.0458385,37.25 38.0125,37.25 C36.7624938,37.25 35.7958368,36.850004 35.1125,36.05 C34.4291633,35.249996 34.0875,34.1083408 34.0875,32.625 L34.0875,25.675 L32.1875,25.675 C32.1374998,25.5583328 32.1125,25.4416672 32.1125,25.325 C32.1125,25.1749992 32.1624995,25.0166675 32.2625,24.85 L34.7375,24.375 C35.0208348,24.5250008 35.2541658,24.7083323 35.4375,24.925 L35.4375,32.625 C35.4375,33.7416723 35.6791643,34.6083302 36.1625,35.225 C36.6458358,35.8416697 37.320829,36.15 38.1875,36.15 C38.9541705,36.15 39.6666634,35.9208356 40.325,35.4625 C40.9833366,35.0041644 41.512498,34.3958371 41.9125,33.6375 C42.312502,32.8791629 42.5125,32.0500045 42.5125,31.15 L42.5125,25.675 L40.6125,25.675 C40.5624998,25.5583328 40.5375,25.4416672 40.5375,25.325 C40.5375,25.1749992 40.5874995,25.0166675 40.6875,24.85 L43.1625,24.375 C43.4458348,24.5250008 43.6791658,24.7083323 43.8625,24.925 L43.8625,35.825 L45.7625,35.825 C45.8125003,35.9416673 45.8375,36.0583327 45.8375,36.175 C45.8375,36.3250008 45.7875005,36.4833325 45.6875,36.65 Z M48.2625,35.675 L48.2125,32.95 C48.3291673,32.8999998 48.454166,32.875 48.5875,32.875 C48.7541675,32.875 48.9124993,32.9249995 49.0625,33.025 L49.5875,35.6 C50.4041708,35.9666685 51.345828,36.15 52.4125,36.15 C53.4458385,36.15 54.262497,35.9333355 54.8625,35.5 C55.462503,35.0666645 55.7625,34.483337 55.7625,33.75 C55.7625,33.149997 55.5333356,32.6416688 55.075,32.225 C54.6166644,31.8083313 53.8958383,31.4583348 52.9125,31.175 C51.7958278,30.8583317 50.9125033,30.5291684 50.2625,30.1875 C49.6124968,29.8458316 49.1500014,29.4541689 48.875,29.0125 C48.5999986,28.5708311 48.4625,28.0416697 48.4625,27.425 C48.4625,26.4416618 48.8416629,25.6666695 49.6,25.1 C50.3583371,24.5333305 51.3958268,24.25 52.7125,24.25 C53.312503,24.25 53.9333301,24.3083328 54.575,24.425 C55.2166699,24.5416672 55.6958318,24.6916657 56.0125,24.875 C56.1958343,25.0916677 56.354166,25.3416653 56.4875,25.625 L56.5375,28.1 C56.404166,28.1500003 56.2791673,28.175 56.1625,28.175 C55.9958325,28.175 55.8375008,28.1250005 55.6875,28.025 L55.1625,25.725 C54.4458298,25.458332 53.654171,25.325 52.7875,25.325 C50.8041568,25.325 49.8125,26.024993 49.8125,27.425 C49.8125,27.8083353 49.9083324,28.1374986 50.1,28.4125 C50.2916676,28.6875014 50.6291643,28.9416655 51.1125,29.175 C51.5958358,29.4083345 52.2624958,29.658332 53.1125,29.925 C54.512507,30.3416687 55.5333301,30.8541636 56.175,31.4625 C56.8166699,32.0708364 57.1375,32.8333287 57.1375,33.75 C57.1375,34.8333387 56.7208375,35.6874969 55.8875,36.3125 C55.0541625,36.9375031 53.8958408,37.25 52.4125,37.25 C51.7124965,37.25 51.0333366,37.1750007 50.375,37.025 C49.7166634,36.8749992 49.1708355,36.6750012 48.7375,36.425 C48.5541658,36.2083323 48.395834,35.9583348 48.2625,35.675 Z M72.7625,37 L67.9375,37 C67.8874998,36.866666 67.8625,36.7500005 67.8625,36.65 C67.8625,36.516666 67.9124995,36.3583342 68.0125,36.175 L69.7125,35.975 L69.7125,28.875 C69.7125,26.5249882 68.7208433,25.35 66.7375,25.35 C65.9541628,25.35 65.2333366,25.5791644 64.575,26.0375 C63.9166634,26.4958356 63.387502,27.1041629 62.9875,27.8625 C62.587498,28.6208371 62.3875,29.4499955 62.3875,30.35 L62.3875,35.925 L63.8375,35.925 C64.104168,35.925 64.2375,36.0416655 64.2375,36.275 C64.2375,36.3750005 64.204167,36.5499987 64.1375,36.8 L64.0875,37 L59.2625,37 C59.2124998,36.866666 59.1875,36.7500005 59.1875,36.65 C59.1875,36.516666 59.2374995,36.3583342 59.3375,36.175 L61.0375,35.975 L61.0375,21.425 L59.0125,21.425 C58.9624998,21.3083328 58.9375,21.1916672 58.9375,21.075 C58.9375,20.9249992 58.9874995,20.7666675 59.0875,20.6 L61.6875,20.125 C61.9708348,20.2750008 62.2041658,20.4583323 62.3875,20.675 L62.3875,27.075 C62.8041688,26.2916628 63.3874963,25.6250028 64.1375,25.075 C64.8875038,24.5249973 65.829161,24.25 66.9625,24.25 C68.29584,24.25 69.3124965,24.6458294 70.0125,25.4375 C70.7125035,26.2291706 71.0625,27.3749925 71.0625,28.875 L71.0625,35.925 L72.5125,35.925 C72.779168,35.925 72.9125,36.0416655 72.9125,36.275 C72.9125,36.3750005 72.879167,36.5499987 72.8125,36.8 L72.7625,37 Z M36.8625,58.3 L36.8625,50.6 L34.9625,50.6 C34.9124998,50.466666 34.8875,50.3500005 34.8875,50.25 C34.8875,50.0833325 34.9374995,49.9166675 35.0375,49.75 L36.8625,49.525 L37.2625,46.9 C37.395834,46.8666665 37.5541658,46.85 37.7375,46.85 C37.8541673,46.85 38.012499,46.8666665 38.2125,46.9 L38.2125,49.5 L41.6625,49.5 C41.929168,49.5 42.0625,49.6166655 42.0625,49.85 C42.0625,49.9500005 42.029167,50.1249988 41.9625,50.375 L41.9125,50.6 L38.2125,50.6 L38.2125,57.8 C38.2125,58.5833372 38.2583329,59.2124976 38.35,59.6875 C38.4416671,60.1625024 38.6333319,60.5083323 38.925,60.725 C39.2166681,60.9416678 39.6708303,61.05 40.2875,61.05 C40.5875015,61.05 40.9249981,61.0250003 41.3,60.975 C41.6750019,60.9249997 42.0458315,60.8500005 42.4125,60.75 C42.5625008,61.016668 42.6541665,61.3333315 42.6875,61.7 C42.3374983,61.8666675 41.9125025,61.9999995 41.4125,62.1 C40.9124975,62.2000005 40.4125025,62.25 39.9125,62.25 C38.9291618,62.25 38.1750026,61.9666695 37.65,61.4 C37.1249974,60.8333305 36.8625,59.8000075 36.8625,58.3 Z M49.5625,61.15 C50.429171,61.15 51.1916634,60.9250022 51.85,60.475 C52.5083366,60.0249978 53.0166649,59.3916707 53.375,58.575 C53.7333351,57.7583292 53.9125,56.816672 53.9125,55.75 C53.9125,54.683328 53.7333351,53.7416708 53.375,52.925 C53.0166649,52.1083292 52.5083366,51.4750022 51.85,51.025 C51.1916634,50.5749978 50.429171,50.35 49.5625,50.35 C48.695829,50.35 47.9333366,50.5749978 47.275,51.025 C46.6166634,51.4750022 46.1083351,52.1083292 45.75,52.925 C45.3916649,53.7416708 45.2125,54.683328 45.2125,55.75 C45.2125,56.816672 45.3916649,57.7583292 45.75,58.575 C46.1083351,59.3916707 46.6124968,60.0249978 47.2625,60.475 C47.9125033,60.9250022 48.6791623,61.15 49.5625,61.15 Z M49.5625,62.25 C48.3958275,62.25 47.3833376,61.9791694 46.525,61.4375 C45.6666624,60.8958306 44.9958358,60.1375049 44.5125,59.1625 C44.0291643,58.1874951 43.7875,57.0500065 43.7875,55.75 C43.7875,54.4499935 44.0291643,53.3125049 44.5125,52.3375 C44.9958358,51.3624951 45.6666624,50.6041694 46.525,50.0625 C47.3833376,49.5208306 48.3958275,49.25 49.5625,49.25 C50.7291725,49.25 51.7416624,49.5208306 52.6,50.0625 C53.4583376,50.6041694 54.1291643,51.3624951 54.6125,52.3375 C55.0958358,53.3125049 55.3375,54.4499935 55.3375,55.75 C55.3375,57.0500065 55.0958358,58.1874951 54.6125,59.1625 C54.1291643,60.1375049 53.4583376,60.8958306 52.6,61.4375 C51.7416624,61.9791694 50.7291725,62.25 49.5625,62.25 Z M24.6375,86.075 C25.837506,86.075 26.8833289,85.7791696 27.775,85.1875 C28.6666711,84.5958304 29.3583309,83.7625054 29.85,82.6875 C30.3416691,81.6124946 30.5875,80.3583405 30.5875,78.925 C30.5875,77.4916595 30.3416691,76.241672 29.85,75.175 C29.3583309,74.108328 28.6666711,73.2791696 27.775,72.6875 C26.8833289,72.0958304 25.837506,71.8 24.6375,71.8 C23.437494,71.8 22.3916711,72.0958304 21.5,72.6875 C20.6083289,73.2791696 19.9166691,74.108328 19.425,75.175 C18.9333309,76.241672 18.6875,77.4916595 18.6875,78.925 C18.6875,80.3750073 18.9333309,81.633328 19.425,82.7 C19.9166691,83.766672 20.6083289,84.5958304 21.5,85.1875 C22.3916711,85.7791696 23.437494,86.075 24.6375,86.075 Z M24.6375,87.25 C23.1541593,87.25 21.8541723,86.9041701 20.7375,86.2125 C19.6208278,85.5208299 18.7541698,84.5541729 18.1375,83.3125 C17.5208303,82.0708271 17.2125,80.6083418 17.2125,78.925 C17.2125,77.258325 17.5208303,75.8041729 18.1375,74.5625 C18.7541698,73.3208271 19.6208278,72.3541701 20.7375,71.6625 C21.8541723,70.9708299 23.1541593,70.625 24.6375,70.625 C26.1208408,70.625 27.4208278,70.9708299 28.5375,71.6625 C29.6541723,72.3541701 30.5208303,73.3208271 31.1375,74.5625 C31.7541698,75.8041729 32.0625,77.258325 32.0625,78.925 C32.0625,80.6083418 31.7541698,82.0708271 31.1375,83.3125 C30.5208303,84.5541729 29.6541723,85.5208299 28.5375,86.2125 C27.4208278,86.9041701 26.1208408,87.25 24.6375,87.25 Z M40.2375,91.625 L34.1625,91.625 C34.1124998,91.5083328 34.0875,91.3916673 34.0875,91.275 C34.0875,91.1249992 34.1374995,90.9666675 34.2375,90.8 L35.9375,90.6 L35.9375,76.075 C35.3874973,76.2583343 34.8958355,76.4583323 34.4625,76.675 C34.2291655,76.3916653 34.0875003,76.083335 34.0375,75.75 C34.8208373,75.2999977 35.745828,74.9375014 36.8125,74.6625 C37.879172,74.3874986 38.8874953,74.25 39.8375,74.25 C41.0875063,74.25 42.1833286,74.5208306 43.125,75.0625 C44.0666714,75.6041694 44.7999974,76.3541619 45.325,77.3125 C45.8500026,78.2708381 46.1125,79.3916602 46.1125,80.675 C46.1125,81.9750065 45.8750024,83.1208284 45.4,84.1125 C44.9249976,85.1041716 44.2666709,85.8749972 43.425,86.425 C42.5833291,86.9750027 41.6125055,87.25 40.5125,87.25 C39.2791605,87.25 38.2041713,86.91667 37.2875,86.25 L37.2875,90.55 L39.9875,90.55 C40.254168,90.55 40.3875,90.6666655 40.3875,90.9 C40.3875,91.0000005 40.354167,91.1749987 40.2875,91.425 L40.2375,91.625 Z M37.2875,75.7 L37.2875,84.95 C38.3041718,85.7333372 39.379161,86.125 40.5125,86.125 C41.3458375,86.125 42.0749969,85.8958356 42.7,85.4375 C43.3250031,84.9791644 43.8124983,84.3458374 44.1625,83.5375 C44.5125018,82.7291626 44.6875,81.791672 44.6875,80.725 C44.6875,79.1083253 44.2375045,77.8125049 43.3375,76.8375 C42.4374955,75.8624951 41.2375075,75.375 39.7375,75.375 C39.3541648,75.375 38.9541688,75.4041664 38.5375,75.4625 C38.1208313,75.5208336 37.7041688,75.5999995 37.2875,75.7 Z M58.0375,80.475 L49.6375,80.475 L49.6375,80.75 C49.6375,82.3666748 50.0583291,83.6541619 50.9,84.6125 C51.7416709,85.5708381 52.8708263,86.05 54.2875,86.05 C54.9375033,86.05 55.6083299,85.9583343 56.3,85.775 C56.9916701,85.5916658 57.5541645,85.3833345 57.9875,85.15 C58.120834,85.283334 58.220833,85.4291659 58.2875,85.5875 C58.354167,85.7458341 58.3958333,85.9083325 58.4125,86.075 C57.0291598,86.8583372 55.5791743,87.25 54.0625,87.25 C52.8958275,87.25 51.879171,86.9791694 51.0125,86.4375 C50.145829,85.8958306 49.4708358,85.1375049 48.9875,84.1625 C48.5041643,83.1874951 48.2625,82.0500065 48.2625,80.75 C48.2625,79.4333267 48.4916644,78.2875049 48.95,77.3125 C49.4083356,76.3374951 50.0624958,75.583336 50.9125,75.05 C51.7625043,74.516664 52.7624943,74.25 53.9125,74.25 C56.979182,74.25 58.5125,76.0749818 58.5125,79.725 C58.379166,80.0083348 58.2208343,80.2583322 58.0375,80.475 Z M49.7375,79.4 L57.1875,79.4 C57.1875,76.6999865 56.0958443,75.35 53.9125,75.35 C52.8124945,75.35 51.8916704,75.716663 51.15,76.45 C50.4083296,77.183337 49.937501,78.1666605 49.7375,79.4 Z M74.2375,87 L69.4125,87 C69.3624998,86.866666 69.3375,86.7500005 69.3375,86.65 C69.3375,86.516666 69.3874995,86.3583342 69.4875,86.175 L71.1875,85.975 L71.1875,78.875 C71.1875,76.5249882 70.1958433,75.35 68.2125,75.35 C67.4291628,75.35 66.7083366,75.5791644 66.05,76.0375 C65.3916634,76.4958356 64.862502,77.1041629 64.4625,77.8625 C64.062498,78.6208371 63.8625,79.4499955 63.8625,80.35 L63.8625,85.925 L65.3125,85.925 C65.579168,85.925 65.7125,86.0416655 65.7125,86.275 C65.7125,86.3750005 65.679167,86.5499987 65.6125,86.8 L65.5625,87 L60.7375,87 C60.6874998,86.866666 60.6625,86.7500005 60.6625,86.65 C60.6625,86.516666 60.7124995,86.3583342 60.8125,86.175 L62.5125,85.975 L62.5125,75.675 L60.6125,75.675 C60.5624998,75.5583327 60.5375,75.4416673 60.5375,75.325 C60.5375,75.1749992 60.5874995,75.0166675 60.6875,74.85 L63.1625,74.375 C63.4458348,74.5250008 63.6791658,74.7083323 63.8625,74.925 L63.6875,77.425 C64.154169,76.4083283 64.7958293,75.6250028 65.6125,75.075 C66.4291708,74.5249973 67.370828,74.25 68.4375,74.25 C69.77084,74.25 70.7874965,74.6458294 71.4875,75.4375 C72.1875035,76.2291706 72.5375,77.3749925 72.5375,78.875 L72.5375,85.925 L73.9875,85.925 C74.254168,85.925 74.3875,86.0416655 74.3875,86.275 C74.3875,86.3750005 74.354167,86.5499987 74.2875,86.8 L74.2375,87 Z",
      "id": "button_1",
      "fill": "#FFFFFF"
    }
  })]), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_pound_2",
      "cx": "845.9",
      "cy": "329.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_pound_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M849.4 330.8h-1.7l-.4 2.1h-.5l.4-2.1h-1.7l-.4 2.1h-.6l.4-2.1h-1.2v-.3c0-.1 0-.2.1-.3h1.2l.5-2.4h-1.6v-.3c0-.1 0-.2.1-.3h1.7l.4-2.1h.5l-.4 2.1h1.7l.4-2.1h.5l-.4 2.1h1.2v.3c0 .1 0 .2-.1.3h-1.2l-.5 2.4h1.6v.6zm-2.2-.6l.5-2.4H846l-.5 2.4h1.7z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_asterisk_2",
      "cx": "788.6",
      "cy": "329.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_asterisk_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M788.9 331.6l-.6-1.3-1 1.1c-.1-.1-.2-.1-.2-.2l-.2-.2 1.1-1-1.3-.6c.1-.2.1-.4.3-.5l1.3.7.1-1.5h.3c.1 0 .2 0 .3.1l-.3 1.5 1.4-.3c0 .1.1.2.1.3v.3l-1.5.2.8 1.3c-.1.1-.2.1-.3.2-.1.1-.2-.1-.3-.1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_zero_2",
      "cx": "817.3",
      "cy": "329.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_zero_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M817.6 333.5c-.5 0-1-.1-1.4-.4-.4-.2-.7-.5-.9-.9-.2-.4-.4-.8-.5-1.3-.1-.5-.2-.9-.2-1.4 0-.5 0-.9.2-1.4.1-.5.3-.9.5-1.3s.5-.7.9-.9c.4-.2.8-.4 1.4-.4.5 0 1 .1 1.4.4.4.3.7.5.9.9.2.4.4.8.5 1.3.1.5.2.9.2 1.4 0 .5-.1.9-.2 1.4-.1.5-.3.9-.5 1.3s-.5.7-.9.9c-.4.3-.9.4-1.4.4zm0-.5c.4 0 .8-.1 1-.3.3-.2.5-.5.7-.8.2-.3.3-.7.4-1.1.1-.4.1-.8.1-1.2 0-.4 0-.8-.1-1.2-.1-.4-.2-.8-.4-1.1-.2-.3-.4-.6-.7-.8-.3-.2-.6-.3-1-.3s-.8.1-1 .3c-.2.2-.5.5-.7.8-.2.3-.3.7-.4 1.1-.1.4-.1.8-.1 1.2 0 .4 0 .8.1 1.2.1.4.2.8.4 1.1.2.3.4.6.7.8.2.2.6.3 1 .3z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_nine_2",
      "cx": "846.1",
      "cy": "300.5",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_nine_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M844.3 303.8c1-.4 1.8-1 2.4-1.6.6-.6 1-1.4 1.2-2.3-.2.4-.5.8-.8 1.1-.3.3-.8.4-1.3.4-.4 0-.9-.1-1.2-.3-.4-.2-.7-.5-.9-.9-.2-.4-.3-.8-.3-1.3s.1-.9.3-1.3c.2-.4.5-.7.9-.9.4-.2.8-.3 1.3-.3s1 .1 1.4.4c.4.2.7.6.9 1 .2.5.3 1 .3 1.6 0 .7-.2 1.4-.5 2-.3.6-.8 1.2-1.3 1.7-.6.5-1.3.9-2.1 1.2-.2-.1-.3-.3-.3-.5zm1.6-3c.4 0 .7-.1 1-.3.3-.2.5-.4.6-.7.2-.3.2-.6.2-1 0-.6-.2-1-.5-1.4-.3-.4-.8-.5-1.3-.5s-1 .2-1.3.5c-.3.4-.5.8-.5 1.4 0 .6.2 1 .5 1.4.3.4.7.6 1.3.6z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_eight_2",
      "cx": "817.3",
      "cy": "300.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_eight_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M818.3 300.6c.6.2 1.1.5 1.3.8.3.4.4.8.4 1.3s-.1.9-.3 1.2c-.2.3-.5.6-.9.8-.4.2-.9.3-1.4.3-.5 0-1-.1-1.4-.3-.4-.2-.7-.4-.9-.8-.2-.3-.3-.7-.3-1.2s.1-.9.4-1.3c.3-.4.7-.7 1.3-.8-.4-.2-.8-.4-1-.7-.2-.3-.3-.7-.3-1 0-.4.1-.7.3-1 .2-.3.5-.5.8-.7.3-.2.7-.2 1.1-.2.4 0 .8.1 1.1.2.3.1.6.4.8.7.2.3.3.6.3 1s-.1.7-.3 1c-.2.3-.6.6-1 .7zm1 2.1c0-.3-.1-.6-.3-.9-.2-.3-.4-.5-.7-.6-.3-.2-.6-.2-1-.2s-.7.1-1 .2c-.3.2-.5.4-.7.6-.2.3-.3.6-.3.9 0 .3.1.6.3.9.2.2.4.4.7.6.3.1.6.2 1 .2s.7-.1 1-.2c.3-.1.5-.3.7-.6.2-.3.3-.5.3-.9zm-.4-3.8c0-.4-.1-.7-.4-1-.3-.3-.7-.4-1.1-.4-.4 0-.8.1-1.1.4-.3.3-.4.6-.4 1s.1.8.4 1c.3.3.7.4 1.1.4.4 0 .8-.1 1.1-.4.2-.2.4-.6.4-1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_seven_2",
      "cx": "788.6",
      "cy": "300.4",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_seven_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M786.8 303.9l3.5-6.9h-3.6l-.3 1.3c-.1.1-.2.1-.2.1h-.2v-1.6l.3-.3h4.5c.1.1.2.3.3.4l-3.6 7.4c-.3-.1-.5-.2-.7-.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_six_2",
      "cx": "845.9",
      "cy": "271.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_six_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M843.9 272.2c.2-.4.5-.8.8-1.1.4-.3.8-.4 1.3-.4.4 0 .9.1 1.2.3.4.2.7.5.9.9.2.4.3.8.3 1.3s-.1.9-.3 1.3c-.2.4-.5.7-.9.9-.4.2-.8.3-1.3.3s-1-.1-1.4-.4c-.4-.3-.7-.6-.9-1-.2-.4-.3-1-.3-1.6 0-.7.2-1.4.5-2 .3-.6.8-1.2 1.4-1.7.6-.5 1.3-.9 2.1-1.2.1.1.2.3.3.5-1 .4-1.8 1-2.4 1.6-.6.6-1.1 1.4-1.3 2.3zm2 3c.5 0 1-.2 1.3-.5.3-.4.5-.8.5-1.4 0-.6-.2-1-.5-1.4-.3-.4-.8-.5-1.3-.5-.4 0-.7.1-1 .3-.3.2-.5.4-.6.7-.2.3-.2.6-.2 1 0 .6.2 1 .5 1.4.3.2.8.4 1.3.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_five_2",
      "cx": "817.3",
      "cy": "271.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_five_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M814.9 270.9l.3-3.2c.1-.1.2-.3.3-.4l.9.3c.3.1.6.1.9.1.2 0 .5 0 .8-.1.3 0 .6-.1.8-.2.1.1.2.3.2.5-.1.1-.3.1-.5.2s-.4.1-.7.1c-.3 0-.5.1-.7.1h-.8c-.3 0-.5-.1-.7-.1l-.2 2.4c.2 0 .4-.1.6-.1h.7c.8 0 1.4.2 1.9.6.5.4.7 1 .7 1.8 0 .5-.1.9-.4 1.3-.2.4-.6.7-1 .9-.4.2-.9.3-1.5.3-.8 0-1.5-.2-2.2-.6 0-.2.1-.3.2-.5.6.3 1.3.5 1.8.5.7 0 1.3-.2 1.7-.5.4-.3.6-.8.6-1.4 0-.6-.2-1-.5-1.4-.3-.3-.8-.5-1.4-.5-.3 0-.5 0-.8.1-.3 0-.5.1-.6.2l-.4-.4z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_four_2",
      "cx": "788.6",
      "cy": "271.5",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_four_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M791.1 275.5h-2.7v-.2c0-.1 0-.2.1-.2l1.2-.1v-1.6H786c-.1-.1-.2-.2-.2-.4l4.2-5.3c.1 0 .1 0 .2.1.1 0 .1.1.2.1v5h1.1c.1 0 .2.1.2.2s0 .2-.1.3v.1h-1.2v1.5h.7c.1 0 .2.1.2.2-.1 0-.1.1-.2.3zm-1.4-2.6V269l-3 3.9h3z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_three_2",
      "cx": "846.1",
      "cy": "242.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_three_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M848.7 239.4l-2.4 2.9h.2c.7 0 1.3.2 1.7.6.4.4.6.9.6 1.6 0 .5-.1.9-.4 1.2-.2.4-.6.6-1 .9-.4.3-.9.3-1.5.3-.8 0-1.5-.2-2.2-.6 0-.2.1-.3.2-.5.6.3 1.3.5 1.8.5.7 0 1.3-.2 1.7-.5.4-.3.6-.8.6-1.3s-.2-.9-.5-1.2c-.3-.3-.8-.4-1.3-.4h-.4c-.1 0-.3 0-.4.1 0 0-.1-.1-.1-.2s-.1-.1-.1-.2l2.5-3h-3l-.3 1.1c-.1.1-.2.1-.2.1h-.2v-1.3l.3-.3h4.1c.2-.1.3 0 .3.2z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_two_2",
      "cx": "817.3",
      "cy": "242.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_two_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M819.8 246.2h-4.3l-.3-.3v-.2c0-.3.1-.7.2-1 .1-.3.4-.6.7-.9.3-.3.7-.7 1.3-1.1.5-.4.8-.7 1.1-.9.3-.3.5-.5.6-.7.1-.2.2-.5.2-.7 0-.4-.1-.8-.4-1-.3-.3-.6-.4-1.1-.4-.7 0-1.3.3-1.8 1-.2-.1-.3-.2-.4-.4.2-.4.6-.6 1-.8.4-.2.8-.3 1.3-.3.6 0 1.2.2 1.6.5.4.4.6.8.6 1.4 0 .3-.1.6-.2.9-.1.3-.3.6-.7.9-.3.3-.7.7-1.3 1.1-.5.4-.8.7-1.1 1-.3.3-.5.5-.6.8-.1.2-.2.5-.2.8h3.6l.3-1.4c.1-.1.2-.1.2-.1h.2v1.6c-.3 0-.4.1-.5.2z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "keypad_number_one_2",
      "cx": "788.6",
      "cy": "242.6",
      "r": "11.6",
      "fill": "#E0E0E0",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "keypad_number_one_1",
      "fill": "#000",
      "fill-rule": "nonzero",
      "d": "M789.8 246.2h-3.5v-.2c0-.1 0-.2.1-.2l1.5-.1v-6.4l-1.6.9c-.1-.1-.2-.3-.3-.4l2.1-1.4c.1 0 .1 0 .2.1.1 0 .1.1.2.1v7.1h1.2c.1 0 .2.1.2.2 0 0-.1.1-.1.3z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73febfe0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/svg/labDoors.vue
// module id = 1008
// module chunks = 1